document.addEventListener('DOMContentLoaded', function () {
  const LIMITED_VARIANT_ID = '47864511103197'; // addon/product variant id
  const DISABLED_TEXT = 'Already added';
  const MESSAGE_TEXT = 'This product is already added to your cart.';
  const ORIGINAL_TEXT_ATTR = 'data-original-button-text';
  const ORIGINAL_HTML_ATTR = 'data-original-button-html';

  const originalFetch = window.fetch.bind(window);

  async function getCart() {
    const res = await originalFetch('/cart.js', { cache: 'no-store' });
    return await res.json();
  }

  function getFormVariantId(form) {
    let idInput = form.querySelector('[name="id"]');

    if (!idInput && form.id) {
      idInput = document.querySelector('[name="id"][form="' + form.id + '"]');
    }

    return idInput ? String(idInput.value) : null;
  }

  function isLimitedForm(form) {
    return getFormVariantId(form) === LIMITED_VARIANT_ID;
  }

  function getSubmitButton(form) {
    return form.querySelector('button[name="add"], button[type="submit"], .product-form__submit');
  }

  function setNormalButtonDisabled(form, disabled) {
    const button = getSubmitButton(form);
    if (!button) return;

    if (!button.hasAttribute(ORIGINAL_TEXT_ATTR)) {
      button.setAttribute(ORIGINAL_TEXT_ATTR, button.textContent.trim());
    }

    if (disabled) {
      button.disabled = true;
      button.classList.add('disabled');
      button.style.pointerEvents = 'none';
      button.style.opacity = '0.6';
      button.textContent = DISABLED_TEXT;
    } else {
      button.disabled = false;
      button.classList.remove('disabled');
      button.style.pointerEvents = '';
      button.style.opacity = '';

      const originalText = button.getAttribute(ORIGINAL_TEXT_ATTR);
      if (originalText) button.textContent = originalText;
    }
  }

  function showAddonMessage(button) {
    const box = button.closest('.ank-addon-box');
    if (!box) return;

    let msg = box.querySelector('.ank-addon-message');

    if (!msg) {
      msg = document.createElement('p');
      msg.className = 'ank-addon-message';
      box.appendChild(msg);
    }

    msg.textContent = MESSAGE_TEXT;
  }

  function setAddonButtonDisabled(button, disabled) {
    if (!button.hasAttribute(ORIGINAL_HTML_ATTR)) {
      button.setAttribute(ORIGINAL_HTML_ATTR, button.innerHTML);
    }

    if (disabled) {
      button.disabled = true;
      button.classList.add('is-added');
      button.style.pointerEvents = 'none';
      button.style.opacity = '0.6';
      button.innerHTML = DISABLED_TEXT;
      // showAddonMessage(button);
    } else {
      button.disabled = false;
      button.classList.remove('is-added');
      button.style.pointerEvents = '';
      button.style.opacity = '';

      const originalHTML = button.getAttribute(ORIGINAL_HTML_ATTR);
      if (originalHTML) button.innerHTML = originalHTML;
    }
  }

  async function forceLimitedQtyOne() {
    const cart = await getCart();

    for (const item of cart.items) {
      if (
        String(item.variant_id) === LIMITED_VARIANT_ID &&
        item.quantity > 1
      ) {
        await originalFetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: item.key,
            quantity: 1
          })
        });

        break;
      }
    }
  }

  async function updateLimitedButtons() {
    const cart = await getCart();

    const alreadyAdded = cart.items.some(function (item) {
      return String(item.variant_id) === LIMITED_VARIANT_ID;
    });

    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      if (!isLimitedForm(form)) return;

      const qtyInput = form.querySelector('[name="quantity"]');
      if (qtyInput) {
        qtyInput.value = 1;
        qtyInput.setAttribute('max', '1');
      }

      setNormalButtonDisabled(form, alreadyAdded);
    });

    document.querySelectorAll('.ank-addon-btn[data-variant-id]').forEach(function (button) {
      const variantId = String(button.getAttribute('data-variant-id'));

      if (variantId === LIMITED_VARIANT_ID) {
        setAddonButtonDisabled(button, alreadyAdded);
      }
    });
  }

  // Addon/recommended button click block
  document.addEventListener('click', async function (e) {
    const button = e.target.closest('.ank-addon-btn[data-variant-id]');
    if (!button) return;

    const variantId = String(button.getAttribute('data-variant-id'));
    if (variantId !== LIMITED_VARIANT_ID) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    const cart = await getCart();

    const alreadyAdded = cart.items.some(function (item) {
      return String(item.variant_id) === LIMITED_VARIANT_ID;
    });

    if (alreadyAdded) {
      setAddonButtonDisabled(button, true);
      return false;
    }

    button.disabled = true;

    await originalFetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: Number(LIMITED_VARIANT_ID),
        quantity: 1
      })
    });

    await updateLimitedButtons();

    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:updated'));

    return false;
  }, true);

  // Normal product form submit block
  document.addEventListener('submit', async function (e) {
    const form = e.target;

    if (!form.matches('form[action*="/cart/add"]')) return;
    if (!isLimitedForm(form)) return;

    const cart = await getCart();

    const alreadyAdded = cart.items.some(function (item) {
      return String(item.variant_id) === LIMITED_VARIANT_ID;
    });

    if (alreadyAdded) {
      e.preventDefault();
      e.stopImmediatePropagation();
      setNormalButtonDisabled(form, true);
      return false;
    }

    const qtyInput = form.querySelector('[name="quantity"]');
    if (qtyInput) {
      qtyInput.value = 1;
      qtyInput.setAttribute('max', '1');
    }

    setTimeout(updateLimitedButtons, 800);
  }, true);

  // AJAX fetch protection
  window.fetch = async function (resource, init = {}) {
    const url = typeof resource === 'string' ? resource : resource.url || '';

    if (url.includes('/cart/add')) {
      const body = init.body;
      let foundLimitedVariant = false;

      if (body instanceof FormData) {
        foundLimitedVariant = String(body.get('id')) === LIMITED_VARIANT_ID;
        if (foundLimitedVariant) body.set('quantity', '1');
      }

      if (typeof body === 'string') {
        try {
          const json = JSON.parse(body);

          if (String(json.id) === LIMITED_VARIANT_ID) {
            foundLimitedVariant = true;
            json.quantity = 1;
          }

          if (Array.isArray(json.items)) {
            json.items = json.items.map(function (item) {
              if (String(item.id) === LIMITED_VARIANT_ID) {
                foundLimitedVariant = true;
                item.quantity = 1;
              }
              return item;
            });
          }

          init.body = JSON.stringify(json);
        } catch (err) {}
      }

      if (foundLimitedVariant) {
        const cart = await getCart();

        const alreadyAdded = cart.items.some(function (item) {
          return String(item.variant_id) === LIMITED_VARIANT_ID;
        });

        if (alreadyAdded) {
          await updateLimitedButtons();

          return new Response(
            JSON.stringify({
              status: 422,
              message: MESSAGE_TEXT
            }),
            {
              status: 422,
              headers: {
                'Content-Type': 'application/json'
              }
            }
          );
        }
      }
    }

    const response = await originalFetch(resource, init);

    if (
      url.includes('/cart/add') ||
      url.includes('/cart/change') ||
      url.includes('/cart/update') ||
      url.includes('/cart/clear')
    ) {
      setTimeout(async function () {
        await forceLimitedQtyOne();
        await updateLimitedButtons();
      }, 700);
    }

    return response;
  };

  updateLimitedButtons();

  const observer = new MutationObserver(function () {
    clearTimeout(window.__limitedButtonTimer);
    window.__limitedButtonTimer = setTimeout(updateLimitedButtons, 400);
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});
